import { render, staticRenderFns } from "./ShippoDimensionsWeightUnit.vue?vue&type=template&id=41708d62&"
import script from "./ShippoDimensionsWeightUnit.vue?vue&type=script&lang=ts&"
export * from "./ShippoDimensionsWeightUnit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports